import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SavingsIcon from "@mui/icons-material/Savings";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import BlockIcon from "@mui/icons-material/Block";
import CountUp from "react-countup";
import useStore from "../../useStore";

const IndividualCount = () => {
  const { dashboardDetails } = useStore();
  console.log(dashboardDetails);
  return (
    <Grid container>
      <Grid item xs={2} sx={{ mx: 1 }}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Customers</Typography>
              <GroupIcon sx={{ color: "#5252ff" }} />
            </Box>
            <Box sx={{ mt: 1 }}>
              <Typography variant="h6" sx={{ color: "#5252ff" }}>
                <CountUp
                  start={0}
                  end={dashboardDetails?.customersCount}
                  duration={2}
                />
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      {/* <Grid item xs={2} sx={{ mx: 1 }}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Agents</Typography>
              <AccountCircleIcon sx={{ color: "#5252ff" }} />
            </Box>
            <Box sx={{ mt: 1 }}>
              <Typography variant="h6" sx={{ color: "#5252ff" }}>
                <CountUp
                  start={0}
                  end={dashboardDetails?.agentsCount}
                  duration={2}
                />
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid> */}
      <Grid item xs={2} sx={{ mx: 1 }}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Active Pigmy</Typography>
              <SavingsIcon sx={{ color: "#5252ff" }} />
            </Box>
            <Box sx={{ mt: 1 }}>
              <Typography variant="h6" sx={{ color: "#5252ff" }}>
                <CountUp
                  start={0}
                  end={dashboardDetails?.activePigmyCount}
                  duration={2}
                />
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={2} sx={{ mx: 1 }}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Active Loan</Typography>
              <AttachMoneyIcon sx={{ color: "#5252ff" }} />
            </Box>
            <Box sx={{ mt: 1 }}>
              <Typography variant="h6" sx={{ color: "#5252ff" }}>
                <CountUp
                  start={0}
                  end={dashboardDetails?.activeLoanCount}
                  duration={2}
                />
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={2} sx={{ mx: 1 }}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Closed Pigmy</Typography>
              <MoneyOffIcon sx={{ color: "#5252ff" }} />
            </Box>
            <Box sx={{ mt: 1 }}>
              <Typography variant="h6" sx={{ color: "#5252ff" }}>
                <CountUp
                  start={0}
                  end={dashboardDetails?.closedPigmyCount}
                  duration={2}
                />
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={2} >
        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Closed Loan</Typography>
              <BlockIcon sx={{ color: "#5252ff" }} />
            </Box>
            <Box sx={{ mt: 1 }}>
              <Typography variant="h6" sx={{ color: "#5252ff" }}>
                <CountUp
                  start={0}
                  end={dashboardDetails?.closedLoanCount}
                  duration={2}
                />
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default IndividualCount;
